const Feature = {
  Coaching: 'coaching',
  Courses: 'courses',
  Interviews: 'interviews',
  Profile: 'profile',
  Questions: 'questions',
  Referrals: 'referrals',
  Guides: 'guides',
};

const TYPES_BY_ROLE_CATEGORY = {
  consulting: [
    'behavioral',
    'estimation',
    'analytical',
    'cross-functional',
    'execution',
    'people-management',
    'project-managing',
    'case-study',
  ],
  data: [
    'sql',
    'data-analysis',
    'data-modeling',
    'data-pipeline-design',
    'statistics-and-experimentation',
    'machine-learning',
    'coding',
    'algorithms',
    'behavioral',
  ],
  design: [
    'product-design',
    'app-critique',
    'behavioral',
    'cross-functional',
    'execution',
    'presentation',
    'portfolio-review',
  ],
  engineering: [
    'coding',
    'algorithms',
    'system-design',
    'behavioral',
    'technical',
    'machine-learning',
    'artificial-intelligence',
    'debugging',
    'code-review',
    'project-discussion',
    'people-management',
    'cross-functional',
  ],
  finance: [
    'case-study',
    'valuation',
    'accounting',
    'mergers-and-acquisitions',
    'enterprise-equity-value',
    'lbo',
    'markets',
    'analytical',
    'estimation',
    'behavioral',
    'data-analysis',
    'execution',
  ],
  marketing: [
    'behavioral',
    'analytical',
    'cross-functional',
    'customer-interaction',
    'execution',
    'data-analysis',
  ],
  operations: [
    'behavioral',
    'cross-functional',
    'execution',
    'project-managing',
    'people-management',
    'analytical',
  ],
  product: [
    'product-design',
    'product-strategy',
    'app-critique',
    'estimation',
    'behavioral',
    'execution',
    'analytical',
    'cross-functional',
    'program-sense',
    'data-analysis',
    'system-design',
    'presentation',
  ],
  sales: [
    'behavioral',
    'customer-interaction',
    'execution',
    'analytical',
  ],
  security: [
    'technical',
    'system-design',
    'coding',
    'behavioral',
  ],
};

module.exports = {
  Feature,
  TYPES_BY_ROLE_CATEGORY,
};
